import { MetaProps } from './index';

export const defaultMeta: Required<MetaProps> = {
  title:
    'Российское общество Знание – проведение мероприятий, гранты, лекции, марафоны',
  description:
    'Открытые уроки, лекции, мастер-классы, дебаты, свободные обсуждения самых актуальных и важных тем современности',
  image: '/img/share/default.jpeg',
  canonicalHref: 'https://www.znanierussia.ru',
};

export type MetaMap = {
  [key: string]: MetaProps;
};

export const metaMap: MetaMap = {
  '/about': {
    title:
      'Информация об общественной некоммерческой организации «Российское общество «Знание»',
    description:
      'Общественная некоммерческая организация «Российское общество «Знание» осуществляет просветительскую работу в 85 субъектах Российской Федерации',
    canonicalHref: 'https://www.znanierussia.ru/about',
  },
  '/about/accreditation': {
    title:
      'Российское общество Знание - Государственная аккредитация программ ВО и СПО',
    description:
      'Экспертная организация Российское общество Знание в государственной аккредитации программ высшего образования и среднего профессионального образования',
    canonicalHref: 'https://www.znanierussia.ru/about/accreditation',
  },
  '/about/contacts': {
    title: 'Контакты Российского общества «Знание»',
    description:
      'Контактная информация «Российского общества «Знание»: электронная почта, телефон, адрес, реквизиты',
    canonicalHref: 'https://www.znanierussia.ru/about/contacts',
  },
  '/about/departments': {
    title: 'Региональные отделения Российского общества Знания',
    description:
      'Региональные отделения и представительства «Российского общества «Знание» во всех округах',
    canonicalHref: 'https://www.znanierussia.ru/about/departments',
  },
  '/about/documents': {
    title:
      'Документы Российского общества Знания – документация по грантам, деятельности, основные документы',
    description:
      'Полная документация «Российского общества «Знание»: описание целей и задач, документы по грантам, победителям конкурсов',
    canonicalHref: 'https://www.znanierussia.ru/about/documents',
  },
  '/about/history': {
    title: 'История Российского общества «Знание»',
    description: 'История и хронология «Российского общества «Знание»',
    canonicalHref: 'https://www.znanierussia.ru/about/history',
  },
  '/about/partners': {
    title: 'Партнеры и спонсоры «Российского общества «Знание»',
    description:
      'Партнеры Российского общества Знания – ключевые партнеры по развитию общества «Знания», Сириус, Росмолодежь, Сбер, VK, ВК, Российское военно-историческое общество, РВИО,  ВШЭ, Высшая школа экономики, Росконгресс, Россия – страна возможностей, Министерство науки и высшего образования Российской Федерации, Минобр науки, Российский союз боевых искусств, РСБИ, Российская академия наук, РЖД, Российские железные дороги, Санкт-Петербургский государственный университет, СПбГУ, Росатом, Большая перемена, Политех, Санкт-Петербургский политехнический университет Петра Великого, Министерство просвещения Российской Федерации, Минпросвещения России, Московский финансово-промышленный университет «Синергия», «Россия – моя история», ГТО, Готов к труду и обороне, МФТИ, Московский физико-технический институт, Твой Ход, Авангард, Национальная ассоциация заслуженных врачей и наставников',
    canonicalHref: 'https://www.znanierussia.ru/about/partners',
  },
  '/about/university': {
    title: 'Сетевой Университет «Знание»',
    description:
      'Сетевой Университет «Знание», лицензия на осуществление образовательной деятельности, Сведения об автономной некоммерческой  организации дополнительного профессионального образования, дополнительное образование, сведения об учредителе, документы, дополнительные профессиональные программы повышения квалификаций, повышение квалификации',
    canonicalHref: 'https://www.znanierussia.ru/about/university',
  },
  '/events': {
    title: 'Календарь мероприятий Российского общества Знание',
    description:
      'Календарь мероприятий: открытые уроки, лекции, мастер-классы, дебаты, свободные обсуждения самых актуальных и важных тем современности на 2021-2022 год',
    canonicalHref: 'https://www.znanierussia.ru/events',
  },
  '/library': {
    title: 'Библиотека знаний Российского общества «Знание»',
    description:
      'Библиотека знаний, полезные материалы, записи лекций и выступлений известных спикеров от Российского общества Знание',
    canonicalHref: 'https://www.znanierussia.ru/library',
  },
  '/management': {
    title: 'Руководство Российского общества «Знание»',
    description:
      'Руководство, руководство Российского общества «Знание», Древаль, Рыбальченко, Колесников, Воронин, Майоров, Нырова, Координационный совет, Наблюдательный совет, Заседания совета',
    canonicalHref: 'https://www.znanierussia.ru/management',
  },
  '/management/coordination-council': {
    title: 'Координационный совет Российского общества «Знание»',
    description:
      'Координационный совет Российского общества «Знание», Глебова, Зинченко, Мау и Члены совета',
    canonicalHref:
      'https://www.znanierussia.ru/management/coordination-council',
  },
  '/management/supervisory-council': {
    title: 'Наблюдательный совет Российского общества «Знание»',
    description:
      'Наблюдательный совет Российского общества «Знание», Кириенко, Мединский, Орешкин, Фурсенко, Духанина',
    canonicalHref: 'https://www.znanierussia.ru/management/supervisory-council',
  },
  '/management/council-meetings': {
    title: 'Заседания совета Российского общества «Знание»',
    description:
      'Заседания Российского общества «Знание», Новые планы, решения и итоги',
    canonicalHref: 'https://www.znanierussia.ru/management/council-meetings',
  },
  '/news': {
    title: 'Новости общества «Знание»',
    description: 'Новости общества «Знание», анонсы',
    canonicalHref: 'https://www.znanierussia.ru/news',
  },
  '/purchases': {
    title: 'Закупки Российского общества «Знание»',
    description:
      'Закупки, активные закупки, архивные закупки, положение о закупочной деятельности',
    canonicalHref: 'https://www.znanierussia.ru/purchases',
  },
  '/award-vote/project': {
    title:
      'Проекты номинированные на Премию «Знание» - Российское Общество «Знание»',
    description:
      'Премия «Знание», Просветительская Премия, Зрительское голосование',
    image: '/img/share/award.jpeg',
    canonicalHref: 'https://www.znanierussia.ru/award-vote/project',
  },
  '/award-vote/speaker': {
    title:
      'Просветители номинированные на Премию «Знание» - Российское Общество «Знание»',
    description:
      'Премия «Знание», Просветительская Премия, Зрительское голосование',
    image: '/img/share/award.jpeg',
    canonicalHref: 'https://www.znanierussia.ru/award-vote/speaker',
  },
  '/award-vote/company': {
    title:
      'Компании номинированные на Премию «Знание» - Российское Общество «Знание»',
    description:
      'Премия «Знание», Просветительская Премия, Зрительское голосование',
    image: '/img/share/award.jpeg',
    canonicalHref: 'https://www.znanierussia.ru/award-vote/company',
  },
  '/ligalektorov': {
    title: 'Лига Лекторов - Российское Общество «Знание»',
    description: 'Лига Лекторов - конкурс для просветителей',
    image: '/img/share/ligalektorov.jpeg',
    canonicalHref: 'https://www.znanierussia.ru/ligalektorov',
  },
  '/ligalektorov/winners': {
    title: 'Победители сезонов Лиги Лекторов - Российское Общество «Знание»',
    description: 'Победители сезонов конкурса «Лига Лекторов»',
    image: '/img/share/ligalektorov.jpeg',
    canonicalHref: 'https://www.znanierussia.ru/ligalektorov',
  },
  '/projects': {
    title: 'Спецпроекты - Российское Общество «Знание»',
    canonicalHref: 'https://www.znanierussia.ru/projects',
  },
  '/become-speaker': {
    title: 'Стать лектором',
    canonicalHref: 'https://www.znanierussia.ru/become-speaker',
  },
  '/become-member': {
    title: ' Стать членом РОЗ',
    canonicalHref: 'https://www.znanierussia.ru/become-member',
  },
};
